import React from "react";
// react plugin that creates an input with badges
import {globals,blog_form} from '../Globals/Globals'
import {useSelector, useDispatch } from 'react-redux';
import { closeModalBlog } from '../../redux/modalSlice'; 
import { updateBlog, addBlog } from '../../redux/blogSlice';
import {Button, Container } from "reactstrap";
import { openModal } from "../../redux/modalSlice";

// core components
import {DsDynamicForm} from "datasync-dynamic-form";
import "../../Components/Modal/Modal.css";

const BlogFormDialog = () => {
  const {blogModal} = useSelector((state) => state.modal);
  const user_foreign_keys = useSelector((state) => state.auth.user_guid);
  const dispatch = useDispatch();
  const {isAdmin} = useSelector((state) => state.auth);
  const {isReadOnly} = useSelector((state) => state.modal);

  React.useEffect(() => {
    console.log("blogModal -> ",blogModal);
    console.log("blogModal.activeObject -> ",blogModal.activeObject);
    console.log("user_foreign_keys ->",user_foreign_keys);

    return function cleanup() {
      document.body.classList.remove("discover");
    };
  });

  return (
      <>
        <div className="main modal-overlay">
          <Button className="modal-top-right-close-button" onClick={()=>{dispatch(closeModalBlog())}}>Fermer</Button>
          <div className="dialog-container">
            <Container>
              {blogModal.activeObject &&
              <h1>{blogModal.activeObject.data_blob.data_tier.blog_title}</h1>}
              {blogModal.activeObject===null &&
              <h1>{"<Nouveau blog>"}</h1>}
              
              <DsDynamicForm
                col_lg={12}
                datasync_url = {globals.datasync_service.url}
                form = {blog_form}
                company_guid = {globals.datasync.platform_company_guid}
                table_guid= {globals.datasync.pf_blogs_table_guid}
                onFormSaved = {(saved_data) => {dispatch(openModal({title:"Blog enregistré"})); console.log("BlogFormDialog::saved_data ->",saved_data);dispatch(addBlog(saved_data)); dispatch(closeModalBlog());}}
                //Let us update the blog
                onFormUpdated = {(updated_data) => {dispatch(openModal({title:"Blog modifié"})); console.log("BlogFormDialog::updated_data ->",updated_data); dispatch(updateBlog(updated_data)); dispatch(closeModalBlog());}}
                onFormFailed = {() => {if (globals.parameters.save_failed_alert) dispatch(openModal({title:"Erreur de sauvegarde du blog"}))}}
                clearOnSave = {true}
                clearOnUpdate = {true}
                sticky_button = {true}
                custom_button_handler = {() => {dispatch(closeModalBlog())}}
                custom_button_caption = {"Fermer"}
                //---
                datasync_object = {blogModal.activeObject}
                data_blob = {blogModal.activeObject?blogModal.activeObject.data_blob:null}
                show_hidden = {isAdmin}
                foreign_keys = {blogModal.activeObject==null?{"user_guid":user_foreign_keys}:null}
                read_only = {isReadOnly}
              />
            </Container>
          </div>
        </div>
      </>
    );
  }

export default BlogFormDialog;